import { render, staticRenderFns } from "./identification.vue?vue&type=template&id=574f86bc&scoped=true"
import script from "./identification.vue?vue&type=script&lang=js"
export * from "./identification.vue?vue&type=script&lang=js"
import style0 from "./identification.vue?vue&type=style&index=0&id=574f86bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574f86bc",
  null
  
)

export default component.exports